import axios from 'axios';

export const headers = {
  'Content-Type': 'application/json',
};

export const backendApi = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API_URL}/api`,
});
export const ephanApi = axios.create({
  baseURL: process.env.REACT_APP_EPHAN_API_URL || 'https://api.e-phan.com/api/v1',
});

backendApi.interceptors.response.use(
  (response) => [null, response.data],
  (error) => [error, null]
);
ephanApi.interceptors.response.use(
  (response) => [null, response.data],
  (error) => [error, null]
);
